const defaultPropValues = {
	textProps: {
		data: {
			title: '',
			body: '',
			footer: ''
		}
	},

	imageProps: {
		data: {
			path: '',
			alt: ''
		}
	},

	heroProps: {
		data: {
			title: '',
			subtitle: '',
			body: '',
			footer: '',
			link: '',
			linkLabel: '',
			path: '',
			alt: '',
			imageMaxHeight: '',
			contentWidth: {}
		}
	},

	headingProps: {
		data: {
			id: '',
			title: '',
			subtitle: '',
			addHeadingBorderTop: true
		}
	},

	carouselProps: {
		data: {
			autoplay: {
				enabled: false,
				interval: 1500
			},
			paginationThumbnails: {
				enabled: false,
				captions: false
			},
			paginationArrows: {
				enabled: false,
				theme: 'light'
			},
			images: [],
			swatches: [{}],
			enableSwatches: false,
			swatchTextColor: 'black'
		}
	},

	videoProps: {
		data: {
			videoSrc: '',
			videoThumbNail: '',
			videoWidth: 'auto',
			videoHeight: 'auto',
			showControls: true,
			autoPlay: true,
			loop: true,
			muted: true,
			VideoTextHeightMQ: {
				enable: false,
				numberOfCols: 3
			}
		}
	},
	youtubeProps: {
		data: {
			videoId: '',
			playlistId: '',
			videoWidth: '640px',
			videoHeight: '360px',
			showControls: true,
			autoPlay: false,
			loop: true,
			muted: false,
			frameborder: false,
			responsive: true,
			allowfullscreen: true
		}
	}
};

export default defaultPropValues;
